import { useState } from "react";
import { api, errText } from "@/lib/api";
import { useToast } from "@/components/dash/Toast";

const when = s => s ? new Date(s).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true }) : null;

function Row({ it, onChanged }) {
  const [confirm, setConfirm] = useState(false), [busy, setBusy] = useState(false);
  const toast = useToast();
  const remove = async () => {
    setBusy(true);
    const r = await api(`/api/admin/access/${encodeURIComponent(it.email)}`, { method: "DELETE" }), d = await r.json();
    setBusy(false); setConfirm(false);
    if (r.ok) { toast(`Removed ${it.email}${d.sessions_ended ? ` · ended ${d.sessions_ended} active session${d.sessions_ended > 1 ? "s" : ""}` : ""}`); onChanged(); }
    else toast(errText(d));
  };
  return (
    <tr data-testid={`access-row-${it.email}`}>
      <td className="num">{it.email}</td>
      <td className="num muted" style={{ fontSize: "12px" }}>{it.added_by}</td>
      <td className="nw">{when(it.added_at)}</td>
      <td className="nw">{when(it.last_login) || <span className="muted">Never</span>}</td>
      <td className="r nw">
        {confirm ? <span className="adm-confirm"><span>Remove access?</span>
          <button className="adm-danger" disabled={busy} onClick={remove} data-testid={`access-confirm-remove-${it.email}`}>{busy ? "Removing…" : "Remove"}</button>
          <button className="btn" onClick={() => setConfirm(false)} data-testid={`access-cancel-remove-${it.email}`}>Cancel</button></span>
          : <button className="btn" onClick={() => setConfirm(true)} data-testid={`access-remove-${it.email}`}>Remove</button>}
      </td>
    </tr>
  );
}

export function ListCard({ data, q, setQ, onChanged }) {
  return (
    <div className="card span-7" data-testid="admin-list-card">
      <div className="card-head"><div><h2>Access list</h2><p className="sub"><span className="num" data-testid="admin-total">{data.total}</span> {data.total === 1 ? "person" : "people"} added by an administrator. Removing someone ends their active sessions immediately.</p></div></div>
      <div className="adm-search"><label className="adm-label" htmlFor="adm-q">Search</label>
        <input id="adm-q" type="search" placeholder="Search by email" value={q} onChange={e => setQ(e.target.value)} data-testid="admin-search-input" /></div>
      <div className="tbl-wrap" style={{ maxHeight: "560px" }}><table data-testid="admin-access-table"><thead><tr><th>Email</th><th>Added by</th><th>Added on</th><th>Last login</th><th className="r"></th></tr></thead>
        <tbody>{data.items.length ? data.items.map(it => <Row key={it.email} it={it} onChanged={onChanged} />)
          : <tr><td colSpan={5} className="empty">{q ? "No emails match this search." : "No one has been added yet."}</td></tr>}</tbody></table></div>
    </div>
  );
}
